










import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class TableComponent extends Vue {
  @Prop()
  public table: HTMLTableElement;

  public title = 'Fedje fel az utolsó oszlop mezőit és ismerje meg a …';

  public lockedFirstColumn: boolean = true; /* depends on table's setting */

  public scrollable: boolean = true;

  public isFirefox: boolean = navigator.userAgent.indexOf('Firefox') !== -1;

  public timeout: number;

  private mounted() {
    this.prepareTable();
  }

  private prepareTable() {
    const table = this.$refs.table as HTMLTableElement;

    for (let i = 0; i < this.table.attributes.length; i ++) {
      const attr = this.table.attributes.item(i);

      if (attr) {
        table.setAttribute(attr.name, attr.value);
      }
    }

    if (this.lockedFirstColumn) {
      table.classList.add('table_locked-first-column');
    }

    table.innerHTML = (this.table.cloneNode(true) as HTMLTableElement).innerHTML;
  }

  public scrollHandling(source: any, target: any): void {
    (this.$refs.table as HTMLTableElement).classList.add('table_shadow-visible');

    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.timeout = setTimeout(() => {
      if (this.scrollable) {
        this.setPosition(this.$refs[source], this.$refs[target]);
      } else {
        this.scrollable = true;
      }
    }, 100);
  }

  public setPosition(source: any, target: any): void {

    if (source && target) {
      const sourcePosition = source.scrollLeft;
      let sourcePercentage: number;
      let targetPosition: number;
      const sourceWidth = (sourcePosition + (source.scrollWidth - (sourcePosition + source.clientWidth)));
      const targetWidth = (target.scrollLeft + (target.scrollWidth - (target.scrollLeft + target.clientWidth)));

      sourcePercentage = Math.trunc(sourcePosition / sourceWidth * 100);
      targetPosition = Math.trunc(sourcePercentage * targetWidth / 100);

      if (sourcePercentage >= 0 && sourcePercentage <= 100) {
        target.scrollLeft = targetPosition;
        this.scrollable = false;
      }
    }
  }
}
